import React, { FC } from 'react'

import { IconPrepareProps } from './IconPrepare.types'
import * as Styled from './styles/IconPrepare.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPrepare: FC<IconPrepareProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPrepareProps['size'],
  isResponsive = false,
}: IconPrepareProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M22.934 7.082v3.95m-1.942-1.977h3.883m-9.988 17.968v7.899m-3.891-3.949h7.781m3.926-12.16-3.793 3.793m16.54 8.953-3.794 3.793M14.523 14.367v-.004a2.986 2.986 0 0 1 4.223.024L39.84 35.719a2.981 2.981 0 0 1-.024 4.218l-.004.004a2.985 2.985 0 0 1-4.218-.023L14.5 18.586a2.981 2.981 0 0 1 .023-4.219Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M36.852 15.09a3.939 3.939 0 1 1-7.878-.002 3.939 3.939 0 0 1 7.878.002Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M21.188 37.09a.262.262 0 0 1-.262.262.261.261 0 0 1-.258-.262.26.26 0 0 1 .258-.262c.144 0 .262.117.262.262Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='m21.188 37.09-.262.262-.258-.262.258-.262.262.262Zm19.871-25.848a.123.123 0 0 1-.125.121.122.122 0 0 1-.121-.12.123.123 0 0 1 .246 0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M40.957 11.242c0 .012-.008.024-.023.024-.012 0-.02-.012-.02-.024s.008-.023.02-.023c.015 0 .023.011.023.023Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M41.23 11.242a.297.297 0 0 1-.296.297.296.296 0 0 1-.293-.297c0-.164.132-.293.293-.293.164 0 .297.13.297.293Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='m41.23 11.242-.296.297-.293-.297.293-.293.297.293ZM9.063 19.184a.123.123 0 1 1-.246 0 .122.122 0 0 1 .245 0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M8.941 19.063a.125.125 0 0 1 0 .25' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M9.137 19.184c0 .109-.09.195-.196.195a.193.193 0 0 1-.195-.195c0-.106.086-.196.195-.196.106 0 .196.09.196.196Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M8.941 19c.106 0 .196.086.196.195 0 .106-.09.196-.196.196'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M8.934 12.09a.994.994 0 1 1-1.989 0 .995.995 0 1 1 1.989 0Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M8.14 12.09a.201.201 0 1 1-.402 0 .2.2 0 1 1 .402 0Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPrepare
